/**
 * @file Checks whether an organization has the external investor portal feature enabled.
 */

import { getConfig } from "@components/Config";

/**
 * Checks whether the given organization id is on the external investor portal allowlist.
 */
const isExternalInvestorPortalEnabled = (organizationId?: string): boolean => {
  const enabledOrgIds = getConfig("EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS") as string[];
  const hasOrganizationId = Boolean(organizationId);

  if (!hasOrganizationId) {
    return false;
  }

  return enabledOrgIds.includes(organizationId);
};

export default isExternalInvestorPortalEnabled;
